
import qs from 'qs'
export default
    name: 'remove-from-comparison-button'
    props: ['bib', 'race_id']
    data: ->
        compare_bibs: []
    computed:
        qstring: ->
            qs.stringify({bibs: @compare_bibs}, { arrayFormat: 'brackets', encodeValuesOnly: true, addQueryPrefix: true})
    mounted: ->
        @compare_bibs = JSON.parse(localStorage.getItem('comparison_' + @race_id)) || []
    methods:
        toggle_click: (bib) ->
            idx = @compare_bibs.indexOf(bib)
            @compare_bibs.splice(idx, 1)

            localStorage.setItem('comparison_' + @race_id, JSON.stringify(@compare_bibs))
            document.location.href = document.location.pathname +  @qstring
            return
